var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 8.222h10M15.889 8.222V16c0 .614-.498 1.111-1.111 1.111H9.222A1.111 1.111 0 0 1 8.112 16V8.222m1.666 0v-1.11c0-.615.497-1.112 1.11-1.112h2.223c.614 0 1.111.497 1.111 1.111v1.111M10.889 11v3.333M13.111 11v3.333"
}))));
export default SvgTrash;